import { Link } from "react-router-dom";
import { Arrow } from "./UI";

// Only populate with client-approved identities. The old strip contained own-brand photos.
export default function LogoStrip({ title, logos = [] }) {
  return (
    <section
      aria-label={title}
      className="sn-logo-strip sn-min-w-0 sn-border-t sn-border-line sn-py-8"
    >
      <h2 className="sn-font-display sn-text-2xl sn-tracking-tight sn-text-forest">
        {title}
      </h2>
      {logos.length ? (
        <div className="sn-mt-8 sn-overflow-hidden">
          <div className="sn-logo-track">
            {[false, true].map((copy) => (
              <div
                key={String(copy)}
                aria-hidden={copy || undefined}
                className={`sn-flex sn-items-center sn-gap-6 sn-pr-6 ${copy ? "sn-logo-copy" : ""}`}
              >
                {logos.map((logo) => (
                  <img
                    key={logo.name}
                    src={logo.src}
                    alt={copy ? "" : logo.name}
                    loading="lazy"
                    className="sn-h-20 sn-w-56 sn-object-contain"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <Link
          to="/contact"
          className="sn-mt-5 sn-inline-flex sn-min-h-[44px] sn-items-center sn-gap-4 sn-text-sm sn-text-muted hover:sn-text-forest"
        >
          {title === "Partnerships"
            ? "For partnership enquiries"
            : "Connect with our team"}
          <Arrow />
        </Link>
      )}
    </section>
  );
}
